import { Card, CardPreview, Checkbox, MessageBar, MessageBarBody, Text, Title3 } from "@fluentui/react-components";
import { Tendering } from "../../../models/tendering";
import { Dispatch, FC, SetStateAction, useState } from "react";
import ConfirmationDialog from "../../dialogs/ConfirmationDialog";

interface TenderingVisibilityProps {
  tenderingDocument: Tendering;
  updateTenderingData: Dispatch<SetStateAction<Tendering>>;
}

const TenderingVisibility: FC<TenderingVisibilityProps> = ({
  tenderingDocument,
  updateTenderingData,
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingValue, setPendingValue] = useState<boolean>(false);

  const isHidden = !!(tenderingDocument.properties.hideTenderList);

  const handleToggle = (_e: any, data: { checked: boolean | "mixed" }) => {
    setPendingValue(!!data.checked);
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    updateTenderingData((prev) => ({
      ...prev,
      properties: {
        ...prev.properties,
        hideTenderList: pendingValue
      }
    }));
    setConfirmOpen(false);
  };

  return (
    <Card className="flex-1 w-2xl">
      <CardPreview>
        <Title3>Synlighet</Title3>
      </CardPreview>
      <div className="flex flex-col gap-4 p-2">
        <MessageBar className="p-2" intent="info">
          <MessageBarBody>
            <Text>
              <strong>Dölj verksamhetslista</strong> innebär att leverantörernas verksamhetslista
              inte visas för kommunerna i ramavtalet. Kommuner kan fortfarande navigera till
              ramavtalet, men listan över anslutna leverantörer och deras verksamhetsinformation
              döljs.
            </Text>
          </MessageBarBody>
        </MessageBar>
        <Checkbox
          label="Dölj verksamhetslista"
          checked={isHidden}
          onChange={handleToggle}
        />
      </div>
      <ConfirmationDialog
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
        title={pendingValue ? "Aktivera dölj verksamhetslista?" : "Avaktivera dölj verksamhetslista?"}
        text={
          pendingValue
            ? "Är du säker på att du vill dölja verksamhetslistan? Kommunerna kommer inte längre att kunna se leverantörernas verksamhetsinformation i detta ramavtal."
            : "Är du säker på att du vill visa verksamhetslistan igen? Kommunerna kommer återigen kunna se leverantörernas verksamhetsinformation i detta ramavtal."
        }
      />
    </Card>
  );
};

export default TenderingVisibility;
